import api from './api'

const gmailService = {
  async poll() {
    const response = await api.post('/gmail/poll')
    return response.data
  },

  async pollAsync() {
    const response = await api.post('/gmail/poll-async')
    return response.data
  },

  async getPollAsyncStatus() {
    const response = await api.get('/gmail/poll-async-status')
    return response.data
  },

  async getStatus() {
    const response = await api.get('/gmail/status')
    return response.data
  },

  async startPolling() {
    const response = await api.post('/gmail/start-polling')
    return response.data
  },

  async getSchedulerStatus() {
    const response = await api.get('/gmail/scheduler-status')
    return response.data
  },

  async startScheduler() {
    const response = await api.post('/gmail/scheduler/start')
    return response.data
  },

  async stopScheduler() {
    const response = await api.post('/gmail/scheduler/stop')
    return response.data
  }
}

export default gmailService
